import { Link, Stack, Text } from "basis";
import { formatMaskedValue } from "library/utils";
import { AccountWithPersonalDetails, PersonalDetails } from "../types";

function phoneNumberToString(phoneNumber?: string): string {
  if (!phoneNumber) {
    return "–";
  }

  return formatMaskedValue(phoneNumber);
}

type Props = {
  accountWithPersonalDetails: AccountWithPersonalDetails;
  canEdit: boolean;
};

export const PhoneNumbers = ({
  accountWithPersonalDetails,
  canEdit,
}: Props) => {
  const { account } = accountWithPersonalDetails;
  const personalDetails =
    accountWithPersonalDetails.personalDetails as PersonalDetails; // TODO: Fix this when the swagger is updated to have masked phone numbers

  return (
    <Stack gap="5">
      <Text as="h3" textStyle="heading5" color="primary.blue.t100">
        Phone numbers
      </Text>
      <Stack gap="3" testId="mobile-number-container">
        <Text>
          <strong>Mobile number</strong>
        </Text>
        <Text testId="mobile-number">
          {phoneNumberToString(personalDetails.mobilePhone)}
        </Text>
        {canEdit && (
          <Link
            href="/manage-personal-details/update-mobile-number"
            newTab={false}
            state={{ account, fullPersonalDetails: personalDetails }}
          >
            Edit
          </Link>
        )}
      </Stack>
      <Stack gap="5" margin="5 0 0 0">
        <Text>
          <strong>Home number</strong>
        </Text>
        <Text testId="home-number">
          {phoneNumberToString(personalDetails.homePhone)}
        </Text>
        {canEdit && (
          <Link
            href="/manage-personal-details/update-home-number"
            newTab={false}
            state={{ account, fullPersonalDetails: personalDetails }}
          >
            Edit
          </Link>
        )}
      </Stack>
      <Stack gap="5" margin="5 0 0 0">
        <Text>
          <strong>Work number</strong>
        </Text>
        <Text testId="work-number">
          {phoneNumberToString(personalDetails.workPhone)}
        </Text>

        <Text>
          {`To update your home or work number please `}
          <Link href="/contact" newTab={false}>
            contact Latitude
          </Link>
          .
        </Text>
        {canEdit && (
          <Link
            href="/manage-personal-details/update-work-number"
            newTab={false}
            state={{ account, fullPersonalDetails: personalDetails }}
          >
            Edit
          </Link>
        )}
      </Stack>
    </Stack>
  );
};
